import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';

import { getUserInformation } from '../Experimentation/Components/ResolveExperimentId';
import { PageExperimentsModel } from '../Experimentation/Models/PageExperimentsModel.csharp';
import { onSessionExpired } from './Modal/LoginModal';

if (!isServerRendering()) {
    // eslint-disable-next-line
    // @ts-ignore
    window.farmasietApi = {
        post
    };
}

// eslint-disable-next-line
declare let experimentsDefinition: PageExperimentsModel;

function headers(additionalHeaders: Record<string, string> | null = null): Record<string, string> {
    let headers: Record<string, string> = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        __RequestVerificationToken: getAntiForgeryToken()
    };

    if (additionalHeaders) {
        headers = { ...headers, ...additionalHeaders };
    }

    if (!isServerRendering() && typeof experimentsDefinition !== 'undefined' && experimentsDefinition) {
        headers[experimentsDefinition.experimentationPathHeaderName] = experimentsDefinition.path || '';
        headers[experimentsDefinition.experimentationUserDataHeaderName] = JSON.stringify(getUserInformation());
    }

    return headers;
}

function getAntiForgeryToken() {
    return (document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement)?.value ?? '';
}

function handleResponse(promise: Promise<Response>, unauthorizedHandler: () => void = onSessionExpired): Promise<Response> {
    return new Promise<Response>((resolve, reject) => {
        promise
            .then((response) => {
                if (response.ok) {
                    resolve(response);
                    return;
                }

                if (unauthorizedHandler && response.status === 401) {
                    unauthorizedHandler();
                }

                reject(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// eslint-disable-next-line
export function put(url: string, body: any = undefined, json = true): Promise<Response> {
    return handleResponse(
        fetch(url, {
            method: 'PUT',
            body: body ? (json ? JSON.stringify(body) : body) : undefined,
            headers: headers(json ? { 'Content-Type': 'application/json' } : null),
            credentials: 'same-origin' // should be default value, but for Safari 11 is not
        })
    );
}

// eslint-disable-next-line
export function post(url: string, body: any = undefined, json = true, unauthorizedHandler: () => void = onSessionExpired): Promise<Response> {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            body: body ? (json ? JSON.stringify(body) : body) : undefined,
            headers: headers(json ? { 'Content-Type': 'application/json' } : null),
            credentials: 'same-origin' // should be default value, but for Safari 11 is not
        }),
        unauthorizedHandler
    );
}

// eslint-disable-next-line
export function postFor<TResult>(url: string, body: any = undefined, unauthorizedHandler: () => void = onSessionExpired): Promise<TResult> {
    return new Promise<TResult>((resolve, reject) => {
        post(url, body, true, unauthorizedHandler)
            .then((result) => result.json())
            .then((result) => {
                resolve(result);
            })
            .catch((error) => reject(error));
    });
}

export function del(url: string, unauthorizedHandler: () => void = onSessionExpired): Promise<Response> {
    return handleResponse(
        fetch(url, {
            method: 'DELETE',
            headers: headers(),
            credentials: 'same-origin'
        }),
        unauthorizedHandler
    );
}

export function deleteFor<TResult>(url: string, unauthorizedHandler: () => void = onSessionExpired): Promise<TResult> {
    return new Promise<TResult>((resolve, reject) => {
        del(url, unauthorizedHandler)
            .then((result) => result.json())
            .then((result) => {
                resolve(result);
            })
            .catch((error) => reject(error));
    });
}

export function get(url: string, additionalHeaders: Record<string, string> | null = null): Promise<Response> {
    return handleResponse(
        fetch(url, {
            credentials: 'same-origin',
            headers: headers(additionalHeaders)
        })
    );
}

export function getFor<TResult>(url: string, headers: Record<string, string> | null = null): Promise<TResult> {
    return new Promise<TResult>((resolve, reject) => {
        get(url, headers)
            .then((result) => result.json())
            .then((result) => {
                resolve(result);
            })
            .catch((error) => reject(error));
    });
}

// eslint-disable-next-line
export function putFor<TResult>(url: string, body: any = undefined): Promise<TResult> {
    return new Promise<TResult>((resolve, reject) => {
        put(url, body)
            .then((result) => result.json())
            .then((result) => {
                resolve(result);
            })
            .catch((error) => reject(error));
    });
}
